"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPrimaryTracker = exports.getPrimaryTracker = void 0;

var _primaryTracker;

var getPrimaryTracker = function getPrimaryTracker() {
  if (!_primaryTracker) {
    throw new Error('usage-tracker-container error. "getPrimaryTracker" was be called before "setPrimaryTracker".');
  }

  return _primaryTracker;
};

exports.getPrimaryTracker = getPrimaryTracker;

var setPrimaryTracker = function setPrimaryTracker(tracker) {
  if (_primaryTracker) {
    throw new Error('usage-tracker-container error. Primary tracker has already been set. You can only set one primary tracker per runtime.');
  }

  _primaryTracker = tracker;
};

exports.setPrimaryTracker = setPrimaryTracker;